import { ShieldCheck } from 'lucide-react'
import { Badge } from '@/components/ui/badge'

export function NoRisk() {
  return (
    <section className="py-16 bg-brand-emerald/10 border-y border-brand-emerald/20">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
        <div className="flex-shrink-0">
          <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-white flex items-center justify-center shadow-lg border-4 border-brand-emerald animate-pulse-subtle">
            <ShieldCheck className="w-12 h-12 md:w-16 md:h-16 text-brand-emerald" />
          </div>
        </div>

        <div className="text-center md:text-left">
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 mb-2">
            <Badge className="bg-brand-emerald hover:bg-emerald-600 text-base py-1 px-4">
              ZERO RISCO
            </Badge>
            <span className="text-brand-emerald font-bold tracking-wider text-sm uppercase">
              Para a escola
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-brand-navy mb-4">
            Você só tem a ganhar
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 text-slate-700 font-medium text-lg">
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-brand-emerald"></span>
              Criar vaga é gratuito
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-brand-emerald"></span>
              Sem mensalidade
            </span>
            <span className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-brand-emerald"></span>
              Só paga se contratar
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}
